import SlideUp from './modules/slideup';
import SlideDown from './modules/slidedown';
{
const
	btn = document.getElementById('btn'),
	list = document.getElementById('list');
// 	clickAnime = () =>{
// 		if(btn.classList.contains('On')){
// 			btn.classList.remove('On');
// 			list.classList.remove('On');
// 		}else{
// 			btn.classList.add('On');
// 			list.classList.add('On');
// 	}
// };

let
	timeoutId,
	copyboxheight,
	slideDown_timer,
	slideUp_timer,
	getAccHeight = ()=>{
		let copybox = list.cloneNode(true);
		list.parentNode.appendChild(copybox);
		copybox.style.cssText = "display:block; height:auto; visibility:hidden;";
		copyboxheight = copybox.offsetHeight;
		list.parentNode.removeChild(copybox);
	},
	AccEvent = () =>{
		getAccHeight();
		let
		listHeight = list.offsetHeight;
		if(listHeight > 1){
			btn.classList.remove('On');
			list.classList.remove('On');
			SlideUp(listHeight,list,slideUp_timer);
		} else {
			list.style.display = "block";
			btn.classList.add('On');
			list.classList.add('On');
			SlideDown(listHeight,copyboxheight,list,slideDown_timer);
			list.animate([ { height: 0 }, { height :  copyboxheight + 'px' }], 300);
		}
};
window.addEventListener('resize', ()=>{
	if ( timeoutId ) return ;
	timeoutId = setTimeout( function () {
		timeoutId = 0 ;
		window.onresize = function() {
			getAccHeight();
		};
	},300);
},false);

if(window.matchMedia('screen and (max-width: 640px)').matches){
	btn.addEventListener('click',AccEvent,false);
	list.style.height = 0;
}

const panels = document.querySelectorAll(".ProductArchiveWrap");
const btn_links = document.querySelectorAll('.ProductArchiveList__link');
;
//Tab
const TabChange = e =>{
	e.stopPropagation();
	let
	current = e.target.dataset.tab,
	text = e.target.innerHTML,
	currentTab = document.querySelector(".ProductArchiveWrap[data-tab='"+current+"']"),
	Mediaflag = window.matchMedia('screen and (max-width: 640px)').matches;
	panels.forEach(elm =>{
		elm.classList.add("ProductArchiveWrap--none");
	});
	btn_links.forEach(elm =>{
		elm.classList.remove("On");
	});
	currentTab.classList.remove("ProductArchiveWrap--none");
	e.target.classList.add('On');
	btn.firstElementChild.innerHTML = text;
	if(Mediaflag){
		btn.classList.remove('On');
		list.classList.remove('On');
		list.style.height = 0;
		list.style.display = 'none';
	}
};

document.querySelectorAll('.ProductArchiveList__link').forEach(elm =>{
	elm.addEventListener('click',TabChange,false)
});

}
